module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showPage) ? _c('div', {
    staticClass: "mycoupons"
  }, [_c('div', {
    staticClass: "tabBar fixed"
  }, [_c('div', {
    class: ['fl', {
      active: _vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('take')
      }
    }
  }, [_c('p', [_vm._v("已领取")])]), _vm._v(" "), _c('div', {
    class: ['fr', {
      active: !_vm.isShow
    }],
    on: {
      "click": function($event) {
        return _vm.switchStatus('untake')
      }
    }
  }, [_c('p', [_vm._v("待领取")])])]), _vm._v(" "), _c('div', {
    staticClass: "redeem"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.redeemCode),
      expression: "redeemCode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入兑换码"
    },
    domProps: {
      "value": (_vm.redeemCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.redeemCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fr",
    on: {
      "click": function($event) {
        return _vm.redeemCoupon()
      }
    }
  }, [_vm._v("兑换")])]), _vm._v(" "), (_vm.isShow && _vm.couponPackageList.length > 0) ? _c('div', {
    staticClass: "cpackage-list"
  }, _vm._l((_vm.couponPackageList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('div', {
      staticClass: "c-tit"
    }, [_vm._v(_vm._s(item.package_coupon_title))]), _vm._v(" "), _c('div', {
      staticClass: "c-price"
    }, [_c('span', [_vm._v(_vm._s(item.package_unit_price))]), _vm._v("元x"), _c('span', [_vm._v(_vm._s(item.package_unit_num))]), _vm._v("张\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-desc"
    }, [_vm._v(_vm._s(item.package_coupon_desc))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "3.2rem"
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.package_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.package_status === 0 ? item.package_error : item.package_shop_desc))]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [_vm._v("\n            ¥"), _c('span', [_vm._v(_vm._s(item.package_selling_price))])])])]), _vm._v(" "), _c('div', {
      staticClass: "btn-buy",
      class: item.package_status === 0 ? 'disabled' : '',
      on: {
        "click": function($event) {
          return _vm.buyCouponPackage(item)
        }
      }
    }, [_vm._v("立即购买")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTake),
      expression: "showTake"
    }]
  }, [(_vm.couponsList.length > 0) ? _c('ul', _vm._l((_vm.couponsList), function(item, index) {
    return _c('li', {
      key: index,
      class: item.coupon_property == 4 ? 'package' : ''
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v("\n          " + _vm._s(item.coupon_property_str) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_image && item.coupon_image.length) ? _c('img', {
      staticStyle: {
        "width": ".8rem",
        "margin-right": ".1rem"
      },
      attrs: {
        "src": item.coupon_image,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "coupon-name-tit ellipses",
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date",
      staticStyle: {
        "margin-top": ".1rem"
      }
    }, [_vm._v("\n                " + _vm._s(item.finished_at) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-colum-se red"
    }, [(item.coupon_type != 5) ? _c('div', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]) : _vm._e(), _vm._v(" "), (item.is_discount == 1 && item.amount == 0) ? _c('span', [_vm._v("全免")]) : _c('span', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (item.is_discount == 1 && item.amount != 0) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.coupon_type != 5) ? _c('div', {
      staticClass: "fs-20 red"
    }, [_vm._v("\n              " + _vm._s(item.use_condition) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "with-top-line flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-ss",
      on: {
        "click": function($event) {
          item.showPackageRule = !item.showPackageRule
        }
      }
    }, [_c('div', {
      class: !item.showPackageRule ? 'ellipses' : '',
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.package_limit || item.description))]), _vm._v(" "), (item.package_rule) ? _c('img', {
      staticStyle: {
        "width": ".2rem",
        "margin": ".1rem 0 0 .1rem"
      },
      attrs: {
        "src": require("../assets/images/icon_arrow_down@2x.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "use-btn",
      on: {
        "click": function($event) {
          return _vm.toUseCoupon(item)
        }
      }
    }, [_vm._v("去使用")])]), _vm._v(" "), (item.showPackageRule) ? _c('p', {
      staticClass: "use-rule",
      domProps: {
        "innerHTML": _vm._s(item.package_rule)
      }
    }) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ac",
    staticStyle: {
      "color": "#666",
      "padding": ".6rem"
    },
    on: {
      "click": _vm.toDisableCoupon
    }
  }, [_vm._v("查看无效优惠券 >")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUntake),
      expression: "showUntake"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showContent),
      expression: "showContent"
    }]
  }, [(_vm.untakeCouponsList != '') ? _c('ul', _vm._l((_vm.untakeCouponsList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "property"
    }, [_vm._v(_vm._s(item.coupon_property_str))]), _vm._v(" "), _c('div', {
      staticClass: "flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-sc"
    }, [(item.coupon_image && item.coupon_image.length) ? _c('img', {
      staticStyle: {
        "width": ".8rem",
        "margin-right": ".1rem"
      },
      attrs: {
        "src": item.coupon_image,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "coupon-name-tit ellipses",
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.coupon_name))]), _vm._v(" "), _c('p', {
      staticClass: "expiry-date",
      staticStyle: {
        "margin-top": ".1rem"
      }
    }, [_vm._v("\n                " + _vm._s(item.coupon_deadline) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-colum-se red"
    }, [(item.coupon_type != 5) ? _c('div', {
      staticClass: "coupon-name-pri"
    }, [(item.is_discount == 0) ? _c('span', {
      staticClass: "money-icon"
    }, [_vm._v("￥")]) : _vm._e(), _vm._v(" "), (item.is_discount == 1 && item.amount == 0) ? _c('span', [_vm._v("全免")]) : _c('span', [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (item.is_discount == 1 && item.amount != 0) ? _c('span', [_vm._v("折")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.coupon_type != 5) ? _c('div', {
      staticClass: "fs-20 red"
    }, [_vm._v("\n              " + _vm._s(item.use_condition) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "with-top-line flex-row-bc"
    }, [_c('div', {
      staticClass: "flex-row-ss",
      on: {
        "click": function($event) {
          item.showPackageRule = !item.showPackageRule
        }
      }
    }, [_c('div', {
      class: !item.showPackageRule ? 'ellipses' : '',
      staticStyle: {
        "max-width": "4rem"
      }
    }, [_vm._v(_vm._s(item.package_limit || item.coupon_description))]), _vm._v(" "), (item.package_rule) ? _c('img', {
      staticStyle: {
        "width": ".2rem",
        "margin": ".1rem 0 0 .1rem"
      },
      attrs: {
        "src": require("../assets/images/icon_arrow_down@2x.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "use-btn",
      on: {
        "click": function($event) {
          return _vm.receiveCoupon(item)
        }
      }
    }, [_vm._v("领取")])]), _vm._v(" "), (item.showPackageRule) ? _c('p', {
      staticClass: "use-rule",
      domProps: {
        "innerHTML": _vm._s(item.package_rule)
      }
    }) : _vm._e()])
  }), 0) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(1)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里什么都没有")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里没有可用的优惠券")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0d74dfd3","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyCoupons.vue
// module id = 410
// module chunks = 7